import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { Cart, updateCart, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

type CustomProperties = { [key: string]: string };

type HandlerType = ApiHandlerDiscreteParameter<
    {
        NewShippingAddressCreated?: string;
        UpdateShippingAddressRequested?: string;
        UpdateBillingAddressRequested?: string;
    },
    UpdateCartApiParameter
>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart and we are trying to set a shipping method on it.");
    }

    const updatedCart: Cart = {
        ...cart,
        properties: {
            ...cart.properties,
            ...props.parameter,
        } as CustomProperties,
    };
    props.apiParameter = { cart: updatedCart };
};

export const UpdateCart: HandlerType = async props => {
    await updateCart(props.apiParameter);
};

export const LoadCart: HandlerType = props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    if (cartId) {
        props.dispatch(loadCart({ cartId }));
    } else {
        props.dispatch(loadCurrentCart());
    }
};

export const chain = [PopulateApiParameter, UpdateCart, LoadCart];

const updateCartProperties = createHandlerChainRunner(chain, "UpdateCartProperties");
export default updateCartProperties;
